import { Lock } from "lucide-react";

/**
 * Password-gated entry to the newsletter admin panel.
 * Pure presentational — receives state from useAdminNewsletter.
 */
const AdminLogin = ({ password, setPassword, onSubmit, loading }) => (
  <div className="min-h-[80vh] flex items-center justify-center bg-ivory px-6">
    <form
      onSubmit={onSubmit}
      data-testid="admin-login-form"
      className="w-full max-w-md bg-white rounded-3xl shadow-xl shadow-charcoal/10 p-10 border border-sand/40"
    >
      <div className="flex items-center gap-3 mb-2">
        <Lock size={18} className="text-terracotta" />
        <span className="text-[11px] tracking-[0.32em] uppercase text-sage">Acceso privado</span>
      </div>
      <h1 className="font-serif text-3xl text-charcoal mb-2">Panel Newsletter</h1>
      <p className="text-sm text-charcoal/65 mb-7 leading-relaxed">
        Solo Marta tiene la contraseña. Si no eres ella, vuelve atrás.
      </p>
      <input
        type="password"
        placeholder="Contraseña"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        autoFocus
        data-testid="admin-password-input"
        className="w-full px-4 py-3 rounded-xl border border-sand/80 focus:border-terracotta focus:ring-1 focus:ring-terracotta outline-none text-charcoal"
      />
      <button
        type="submit"
        disabled={loading}
        data-testid="admin-login-btn"
        className="mt-5 w-full bg-charcoal text-ivory rounded-full py-3.5 text-sm font-medium hover:bg-terracotta transition-colors disabled:opacity-50"
      >
        {loading ? "Verificando…" : "Entrar"}
      </button>
    </form>
  </div>
);

export default AdminLogin;
